<template>
  <div class="detail__main__container w-100">
    <div class="detail__header">
      <span>
        <i :class="componentIcon"></i>
        <h5>{{ componentTitle }}</h5>
      </span>
      <span class="detail__header__actions">
        <i
          v-if="open"
          :class="[customActionIcon, customActionIconClass]"
          @click.stop="triggerActionFunction"
        ></i>
        <i :class="open ? 'fas fa-eye' : 'fas fa-eye-slash'"
          @click.stop="toggleOpen"
        ></i>
      </span>
      <!-- add a component here when calling the component -->
    </div>
    <slot v-if="open"></slot>
  </div>
</template>

<script>
export default {
  name: 'detailContainer',
  props: {
    componentIcon: {
      type: String,
      default: null
    },
    componentTitle: {
      type: String,
      default: null
    },
    customActionIcon: {
      type: String,
      default: null
    },
    customActionIconClass: {
      type: String,
      default: ''
    },
    defaultOpen: {
      type: Boolean,
      default: false
    },
    customActionFunction: {
      type: Function,
      default: function () {}
    },
    isFollowupRapido: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: this.defaultOpen
    }
  },
  methods: {
    toggleOpen () {
      this.open = !this.open
    },
    triggerActionFunction () {
      this.customActionFunction()
    }
  }
}
</script>

<style lang="scss">
.detail__main__container {
  border-radius: 4px;
  padding: 1rem 1.5rem;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.10);
  color: #6c757d;

  @media screen and (max-width: 480px) {
    padding: 0.5rem 1rem;
  }
}

.detail__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-block: 1rem;

  &__actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i {
      cursor: pointer;
    }
  }

  span {
    display: flex;
    align-items: center;
    gap: 1rem;

    h5 {
      margin: 0;
      font-size: 1.2rem;
      font-weight: 600;
      line-height: 100%;
    }
  }
}

.icon__color {
  color: #6f42c1 !important;
  font-size: 1.1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/components/detailContainer/detailContainer.vue